<template>
  <template v-if="authReady">
    <Login v-if="!authUser" />
    <div v-else-if="settings.appReady">
    <div class="flex flex-start">
      <!-- HR Monitor -->
      <div class="grid-heart" style="width:30vw;height:60vh; background-color">
        <heartMonitor @dblclick="discard" @contextmenu="discard" 
          style="margin-top:1.4vh;"   
          :hrConnected="hrConnected" 
          :heartRate="heartRate" 
          :user="settings.user"
          @touch="bleReconnect"/>        
        <!-- Age Select -->
        <div v-if="settings.mode=='setup'">
          <ageSelect @dblclick="discard" @contextmenu="discard"
            style="margin-top:2vh;" 
            :age="settings.user.age"
            @up="ageUp"
            @down="ageDown">
          </ageSelect>
        </div>
        <!-- Target Zone, and Zone Notifications -->
        <div v-else>
          <targetZone @dblclick="discard" @contextmenu="discard" @touchstart="discard"
            :user="settings.user" 
            :zone="activeZone"
            :colorZones="settings.colorZones">
          </targetZone>
          <zoneNotification @dblclick="discard" @contextmenu="discard" @touchstart="discard"
            :user="settings.user"
            :zone="activeZone"
            :hrConnected="hrConnected"
            :heartRateZone="heartRateZone"
            :heartRate="heartRate">
          </zoneNotification>
        </div>
      </div>
      <!-- Zones -->
      <div @dblclick="discard" @contextmenu="discard" @touchstart="discard">
        <div v-for= "n in 5">
          <hrZone class="flex justify-content-center" 
            style="height:12vh;width:20vw;"
            :style="{backgroundColor:settings.colorZones[Math.abs(5 - n)]}" 
            :zone="Math.abs(5-n+1)"
            :user="settings.user"
            :mode="settings.mode"></hrZone>        
        </div>
      </div>  
      <!-- HR Meter -->
      <div @dblclick="discard" @contextmenu="discard" @touchstart="discard"
        style="width:4vw;height:60vh;margin-left:-2vw;">
        <hrMeter :heartRate="heartRate"
          :user="settings.user"></hrMeter>
      </div>
      <!-- Main Display -->
      <!-- Volume -->
      <volume style="position:fixed;top:3.5vh;right:1.5vh;" 
        :volume=settings.user.volume
        @click="toggleVolume">
      </volume>
      <!-- Active Program / Timers -->
      <div style="margin-left:-2vw;">
        <div @contextmenu="discard" style="width:50vw;height:48vh;background-color:rgba(47, 0, 255, 0.161);">
          <!-- Program Name / Time Display -->
          <p class="h2" style="margin-top:0vw;padding-top:1vw;">
          <span v-if="debug">Simulation - </span>{{ activeProgram.name }}</p>
          <p class="h1" style="margin-top:0vw;margin-bottom:0vw;padding-top:0vw;">{{ timeDisplay(programTime) }}</p>
          
          <!-- Elapsed Time / Interval Time -->
          <div class="flex">
            <div v-if="settings.mode=='setup'" style="width:25vw;">
            </div>
            <div v-else style="width:25vw;">
              <p class="h3" style="margin-top:0vw;margin-bottom:0vw;padding-top:3vw;">Elapsed Time</p>
              <p class="h2" style="font-size:4vw;line-height:2vw;margin-top:0vw;padding-top:1vw;">{{ timeDisplay(programElapsedTime) }}</p>
            </div>

            <div style="width:25vw;">
              <div v-if="settings.mode=='setup'">
                <intervalTime style="padding-right:1vw;" 
                  :intervalTime=activeProgram.intervalTime
                  @up="intervalTimeUp"
                  @down="intervalTimeDown">
                </intervalTime>
              </div>
              <div v-else>
                <p class="h3" style="margin-top:0vw;margin-bottom:0vw;padding-top:3vw;">Interval Time Remaining</p>
                <p class="h2" style="font-size:4vw;line-height:2vw;margin-top:0vw;padding-top:1vw;">{{ timeDisplay(intervalTimeRemaining) }}</p>
              </div>
            </div>
          </div>
        </div>
        <!-- Start Stop Controls -->
        <div @dblclick="discard" @contextmenu="discard"  
          class="flex justify-content-center" style="width:50vw;height:12vh;background-color:rgba(47, 0, 255, 0.161);">
          <controls @dblclick="discard" @contextmenu="discard" 
            @start="start" @stop="stop" @reset="reset" :mode="settings.mode"></controls>
        </div>
      </div>
    </div>

    <!-- Secondary Display -->
    <div class="flex justify-content-center" style="width:100vw;height:40vh;overflow:hidden;">
      <div v-if="settings.mode=='setup'">
        <programSetup @dblclick="discard" @contextmenu="discard"
          style="box-sizing: content-box; width:30vw;height:40vh;background-color:rgba(47, 0, 255, 0.161);"
          :selectedProgram = "settings.selectedProgram"
          :programs = "programs"
          @previous="selectPreviousProgram"
          @next="selectNextProgram"
          @up="programTimeUp"
          @down="programTimeDown">
        </programSetup>
      </div>
      <div v-else>
        <feedback @dblclick="discard" @contextmenu="discard" @touchstart="discard" style="width:30vw;height:40vh;background-color:rgba(47, 0, 255, 0.161);"
          :zone="activeZone"
          :hrConnected="hrConnected"
          :heartRateZone="heartRateZone">
        </feedback>
      </div>
      <!-- Program Progress -->
      <program @dblclick="discard" @contextmenu="discard" @touchstart="discard" style="width:70vw;height:40vh;" 
      :program="programs[settings.selectedProgram]" 
      :mode="settings.mode" 
      :intervals = "settings.intervals"
      :activeInterval="settings.activeInterval"></program>
    </div>
  </div>
  </template>
</template>

<script>
import heartMonitor from './components/HeartMonitor.vue'
import hrZone from './components/HrZone.vue'
import hrMeter from './components/HrMeter.vue'
import program from './components/program.vue'
import feedback from './components/feedback.vue'
import programSetup from './components/programSetup.vue'
import intervalTime from './components/intervalTime.vue'
import ageSelect from './components/ageSelect.vue'
import controls from './components/controls.vue'
import targetZone from './components/targetZone.vue'
import zoneNotification from './components/zoneNotification.vue'
import volume from './components/volume.vue';
import Login from './components/Login.vue';
import { auth } from './firebase.js';
import { onAuthStateChanged } from 'firebase/auth';

const HEART_RATE_SERVICE = 'heart_rate';
const HEART_RATE_MEASUREMENT_CHARACTERISTIC = '00002a37-0000-1000-8000-00805f9b34fb';
const MAX_AGE = 126;

export default {
  name: 'App',
  components: {
    Login,
    heartMonitor,
    hrZone,
    hrMeter,
    program,
    feedback,
    programSetup,
    intervalTime,
    ageSelect,
    controls,
    targetZone,
    zoneNotification,
    volume,
  },
  setup() {
  },
  created() {
    onAuthStateChanged(auth, (user) => {
      this.authUser = user;
      this.authReady = true;
    });
  },
  data() {
    return {
      authUser: null,
      authReady: false,
      debug:false,
      programs:[
        {
          name: "Walking 1",
          time:1800,
          intervalTime:60,
          intervals:[
            {zone:1,multiple:2},
            {zone:2,multiple:1}
          ]
        },
      ],
      settings: {
        simCount:0,
        simHeartRate:90,
        simHrDirection:1,
        serverAddress:"http://192.168.1.18",
        port:3020,
        appReady:false,
        intervals:[],
        user:{
          age:26,
          maxHR:194,
          zones:[],
          volume:0,
        },
        colorZones:['rgb(176,172,172)','rgb(95,172,244)','rgb(185,227,155)','rgb(233,161,58)','rgb(255,50,36)'],
        selectedProgram:0,
        preview:true,
        activeInterval:-1,
        mode:"setup", /* setup, running, paused, done */
      },
      bleDevice: null,
      bleServer: null,
      bleCharacteristic: null,
      wakeLock: null,
      audioAssets: {},
      hrConnected: 0,
      heartRate: 0,
      programTime: 0,
      programElapsedTime: 0,
      intervalTimeRemaining: 0,
      intervalTimer: -1,
    }
  },
  methods: {
    discard(ev) {
      ev.preventDefault();
    },
    calculateZones() {
      this.settings.user.zones[0] = {intensity:"Very Light", name:"Z1", lower:Math.ceil(.5 * this.settings.user.maxHR), upper:Math.ceil(.6 * this.settings.user.maxHR)-1}
      this.settings.user.zones[1] = {intensity:"Light", name:"Z2", lower:Math.ceil(.6 * this.settings.user.maxHR), upper:Math.ceil(.7 * this.settings.user.maxHR)-1}
      this.settings.user.zones[2] = {intensity:"Moderate", name:"Z3", lower:Math.ceil(.7 * this.settings.user.maxHR), upper:Math.ceil(.8 * this.settings.user.maxHR)-1}
      this.settings.user.zones[3] = {intensity:"Hard", name:"Z4", lower:Math.ceil(.8 * this.settings.user.maxHR), upper:Math.ceil(.9 * this.settings.user.maxHR)-1}
      this.settings.user.zones[4] = {intensity:"Maximum", name:"Z5", lower:Math.ceil(.9 * this.settings.user.maxHR), upper:Math.ceil(this.settings.user.maxHR)}
    },
    initialiseIntervals() {
      this.settings.intervals = [];
      var stepCount = this.activeProgram.time / this.activeProgram.intervalTime;
      var step = 0;
        
      while (step < stepCount) {
        for (var i=0; i<this.activeProgram.intervals.length;i++) {
          for (var j=0; j<this.activeProgram.intervals[i].multiple;j++) {
            if (step * this.activeProgram.intervalTime >= this.activeProgram.time)
              break;
            this.settings.intervals[step++] = {zone:this.activeProgram.intervals[i].zone};
          }
        }
      }
    },
    selectPreviousProgram() {
      if (this.settings.selectedProgram == 0) {
        this.settings.selectedProgram = this.programs.length-1;
      }
      else {
        this.settings.selectedProgram--;
      }
      this.programTime = this.activeProgram.time;
      this.initialiseIntervals();
      this.saveUserSettings();
    },
    selectNextProgram() {
      if (this.settings.selectedProgram == this.programs.length-1) {
        this.settings.selectedProgram = 0;
      }
      else {
        this.settings.selectedProgram++;
      }
      this.programTime = this.activeProgram.time;
      this.initialiseIntervals();
      this.saveUserSettings();
    },
    programTimeUp() {
      if (this.activeProgram.time < 43200) {
        this.activeProgram.time+=60;
        this.initialiseIntervals();
        this.programTime = this.activeProgram.time;
      }
    },
    programTimeDown() {
      if (this.activeProgram.time > 120) {
        this.activeProgram.time-=60;
        this.initialiseIntervals();
        this.programTime = this.activeProgram.time;
      }
    },
    intervalTimeUp() {
      if (this.activeProgram.intervalTime < 600) {
        this.activeProgram.intervalTime += 30;
        this.activeProgram.time += this.intervalCount * 30 
        this.initialiseIntervals();
        this.programTime = this.activeProgram.time;
      }
    },
    intervalTimeDown() {
      if (this.activeProgram.intervalTime > 30) {
        if ((this.activeProgram.intervalTime - 30) * this.intervalCount < this.activeProgram.time) {
          this.activeProgram.intervalTime -= 30;
          this.activeProgram.time -= this.intervalCount * 30 
          this.initialiseIntervals();
          this.programTime = this.activeProgram.time;
        }
      }
    },
    calculateMaxHR() {
      this.settings.user.maxHR = 220 - this.settings.user.age;
    },
    ageUp() {
      if (this.settings.user.age < MAX_AGE) {
        this.settings.user.age++;
        this.calculateMaxHR();
        this.calculateZones();
        this.saveUserSettings();
      }
    },
    ageDown() {
      if (this.settings.user.age > 11) {
        this.settings.user.age--;
        this.calculateMaxHR();
        this.calculateZones();
        this.saveUserSettings();
      }
    },
    setAudioVolume() {
      let audioVolume;

      if (this.settings.user.volume == 0 || this.settings.user.volume == undefined) {
        audioVolume = 0;
      }
      else {
        audioVolume = this.settings.user.volume / 3; 
      }

      Object.values(this.audioAssets).forEach(a => { a.volume = audioVolume; });
    },
    toggleVolume() {
      if (this.settings.user.volume == undefined) {
        this.settings.user.volume = 0;
      }

      this.settings.user.volume++;
      
      if (this.settings.user.volume > 3) {
        this.settings.user.volume = 0;
      }
      this.setAudioVolume();
      this.saveUserSettings();
    },
    async loadPrograms() {
      try {
        const res = await fetch('/assets/programs.json');
        if (!res.ok) throw new Error();
        const data = await res.json();
        if (Array.isArray(data) && data.length > 0) {
          this.programs = data;
        }
      } catch {
        // fall back to the single hardcoded program already in data()
      }
      if (this.settings.selectedProgram >= this.programs.length) {
        this.settings.selectedProgram = 0;
      }
    },
    saveUserSettings() {
      localStorage.setItem("cardium",JSON.stringify({user:this.settings.user, selectedProgram:this.settings.selectedProgram}));
    },
    loadUserSettings() {
      var saved = localStorage.getItem("cardium");

      if (saved != undefined && saved != null) {
        const parsed = JSON.parse(saved);
        this.settings.user = parsed.user;

        if (this.settings.user.age < 10 || this.settings.user.age > MAX_AGE) {
          this.settings.user.age = 25;
          this.calculateMaxHR();
          this.calculateZones();
        }

        if (parsed.selectedProgram != undefined) {
          this.settings.selectedProgram = parsed.selectedProgram;
        }
      }

      this.setAudioVolume();
    },
    updateZoneSegment() {
      if (this.programTime % this.activeProgram.intervalTime == 0) {
        this.settings.activeInterval++;
      }
    },
    updateIntervalTimeRemaining() {
      if (this.programTime < this.activeProgram.intervalTime) {
        this.intervalTimeRemaining = this.programTime;
      }
      else {
        this.intervalTimeRemaining = this.programTime % this.activeProgram.intervalTime;
      }
    },
    startProgramTimer() {
      this.intervalTimer = setInterval(() => {
        this.programTime--;
        this.programElapsedTime++;
        if (this.hrConnected == 0 && this.programElapsedTime % 5 == 0 && this.intervalTimeRemaining > 5) {
          if (this.heartRateZone < this.activeZone && this.settings.user.volume > 0) {
            this.playAudio('toolow');
          }
          else if (this.heartRateZone > this.activeZone && this.settings.user.volume > 0) {
            if (this.heartRate < this.settings.user.maxHR)
            this.playAudio('toohigh');
          }
          else if (this.settings.user.volume > 0) {
            this.playAudio('inzone');
          }
        }

        if (this.hrConnected == 0) {
          if (this.heartRate >= this.settings.user.maxHR && this.settings.user.volume > 0) {
            this.playAudio('maxhr');
          }
        }

        this.updateZoneSegment();
        this.updateIntervalTimeRemaining();
        if (this.programTime <= 0) {
          this.settings.mode = "done"
          clearTimeout(this.intervalTimer);
          this.releaseWakeLock();
        }
        if (this.debug) {
          this.simUpdate();
        }
      },this.simTime);
    },
    start() {
      this.requestWakeLock();

      if (this.settings.mode == "setup" || this.settings.mode == "paused") {
        if (this.settings.mode == "setup") {
          this.settings.activeInterval = 0;
        }
        
        this.settings.mode = "running";
        this.setAudioVolume();
        this.unlockAudio();
        this.startProgramTimer();
      }

    },
    stop() {
      this.releaseWakeLock();

      if (this.settings.mode == "running") {
        clearTimeout(this.intervalTimer);
        this.settings.mode = "paused";
      }
    },
    simUpdate() {
      this.settings.simHeartRate += this.settings.simHrDirection;
      if (this.settings.simHeartRate > (this.settings.user.maxHR*1.20)) {
        this.settings.simHrDirection = -1;
      }
      else if (this.settings.simHeartRate < this.settings.user.maxHR*.55) {
        this.settings.simHrDirection = 1;
      }
      this.heartRate = this.settings.simHeartRate;
    },
    reset() {
      if (this.settings.mode == "paused" || this.settings.mode == "done") {
        this.settings.simCount = 0;
        this.settings.mode = "setup";
        this.settings.activeInterval=-1;
        this.intervalTimeRemaining=0;
        this.programElapsedTime=0;
        this.programTime = this.activeProgram.time;
      }
      else {
        this.settings.simCount += 1;
        if (this.settings.simCount == 10) {
          this.debug = !this.debug;
          this.settings.simCount = 0;
          if (this.debug) {
            this.hrConnected = 0;
            this.heartRate = this.settings.user.maxHR*.5;
            alert("Simulation Active.");
          }
          else {
            alert("Simulation Disabled.");
            this.hrConnected = (this.bleServer && this.bleServer.connected) ? 0 : -1;
            this.heartRate = 0;
          }
          clearTimeout(this.intervalTimer);
          //this.startProgramTimer();
        }
      }
    },
    timeDisplay(timeSeconds) {
      const hours = Math.floor(timeSeconds / 3600);
      const secondsRemaining = timeSeconds%3600;
      const minutes = Math.floor(secondsRemaining / 60);
      const seconds = secondsRemaining % 60;
      
      const tHours = hours<10?"0"+hours:hours;
      const tMinutes = minutes<10?"0"+minutes:minutes;
      const tSeconds = seconds<10?"0"+seconds:seconds;

      return tHours + ":" + tMinutes + ":" + tSeconds;
    },
    parseHeartRate(value) {
      const flags = value.getUint8(0);
      const rate16Bits = flags & 0x1;
      let heartRate;
      if (rate16Bits > 0) {
        heartRate = value.getUint16(1, true);
      } else {
        heartRate = value.getUint8(1);
      }
      return heartRate;
    },
    unlockAudio() {
      const savedVolume = Object.values(this.audioAssets)[0]?.volume ?? 0;
      Object.values(this.audioAssets).forEach(audio => {
        audio.volume = 0;
        audio.play().then(() => {
          audio.pause();
          audio.currentTime = 0;
          audio.volume = savedVolume;
        }).catch(() => {});
      });
    },
    playAudio(assetId) {
      const audio = this.audioAssets[assetId];
      if (audio) {
        audio.currentTime = 0;
        audio.play().catch(() => {});
      }
    },
    async requestWakeLock() {
      try {
        if (navigator.wakeLock) {
          this.wakeLock = await navigator.wakeLock.request('screen');
        }
      } catch(err) {
        console.log('Wake lock unavailable:', err);
      }
    },
    async releaseWakeLock() {
      if (this.wakeLock) {
        await this.wakeLock.release();
        this.wakeLock = null;
      }
    },
    async ble() {
      try {
        await this.getBleDevice();
        await this.bleConnect();
      }
      catch(err) {
        this.hrConnected = -2;
        console.log(err);
      }
    },
    async getBleDevice() {
      if (!navigator.bluetooth) {
        throw new Error('Web Bluetooth not supported — use Chrome/Edge over HTTPS or localhost');
      }
      this.bleDevice = await navigator.bluetooth.requestDevice({
        filters: [{ services: [HEART_RATE_SERVICE] }],
      });
      this.bleDevice.addEventListener('gattserverdisconnected', () => this.onDisconnect());
    },
    async bleConnect() {
      this.bleServer = await this.bleDevice.gatt.connect();
      const service = await this.bleServer.getPrimaryService(HEART_RATE_SERVICE);
      this.bleCharacteristic = await service.getCharacteristic(HEART_RATE_MEASUREMENT_CHARACTERISTIC);
      await this.bleCharacteristic.startNotifications();
      this.bleCharacteristic.addEventListener('characteristicvaluechanged', (event) => {
        this.heartRate = this.parseHeartRate(event.target.value);
      });
      this.hrConnected = 0;
      console.log('connected to device', this.bleDevice.name);
    },
    async bleReconnect() {
      if (this.hrConnected == -1 || this.hrConnected == -2) {
        try {
          if (!this.bleDevice) {
            await this.getBleDevice();
          }
          await this.bleConnect();
        }
        catch(err) {
          this.hrConnected = -2;
          console.log(err);
        }
      }
    },
    onDisconnect() {
      console.log('device disconnected');
      this.hrConnected = -1;
    },
  },
  computed: {
    activeProgram() {
      return this.programs[this.settings.selectedProgram];
    },
    intervalCount() {
      let count = 0;
      for (let i=0; i<this.activeProgram.intervals.length; i++) {
        count += this.activeProgram.intervals[i].multiple;
      }

      return count;
    },
    activeZone() {
      if (this.settings.activeInterval > -1 && this.settings.activeInterval < this.settings.intervals.length) {
        return this.settings.intervals[this.settings.activeInterval].zone;
      }
      else {
        return -1;
      }
    },
    programTargetZone() {
      if (this.mode == "running") {
        return this.activeProgram
      }
      else {
        return -1;
      }
    },
    heartRateZone() {
      if (this.hrConnected == 0) {
        if (this.heartRate < this.settings.user.zones[0].lower) {
          return 0;
        }
        else if (this.heartRate > this.settings.user.zones[4].upper) {
          return 6;
        }
        else {
          for (var i=0; i<this.settings.user.zones.length; i++) {
            if (this.heartRate >= this.settings.user.zones[i].lower && this.heartRate <= this.settings.user.zones[i].upper) {
              return i+1;
            }
          }
        }
      }
      return -1;
    },
    simTime() {
      return this.debug?1000:1000;
    },
  },
  async mounted() {
    this.audioAssets = {
      toohigh: new Audio('/assets/sounds/too-high.m4a'),
      toolow:  new Audio('/assets/sounds/too-low.m4a'),
      inzone:  new Audio('/assets/sounds/in-zone.m4a'),
      maxhr:   new Audio('/assets/sounds/max-hr.m4a'),
    };

    // Re-acquire wake lock if user returns mid-workout
    document.addEventListener('visibilitychange', async () => {
      if (document.visibilityState === 'visible' && this.settings.mode === 'running' && !this.wakeLock) {
        await this.requestWakeLock();
      }
    });

    this.hrConnected = -2;

    this.loadUserSettings();

    await this.loadPrograms();

    this.settings.appReady = true;

    this.settings.user.maxHR = 220 - this.settings.user.age;

    // BLE connection is user-initiated: tap the heart monitor to connect.
    // Web Bluetooth requires a user gesture; calling requestDevice() here would throw.

    this.calculateZones();
    this.initialiseIntervals();
    this.programTime = this.activeProgram.time;
  },
}

</script>

<style>
* {
  box-sizing: border-box!important;
  -webkit-tap-highlight-color: transparent;
}

html {
  height: 100%;
  overflow: hidden;
  background-color: black;
}

body {
  box-sizing: border-box;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  background-color: black;
  color: white;
  margin: 0;
  padding: env(safe-area-inset-top, 0px) env(safe-area-inset-right, 0px) env(safe-area-inset-bottom, 0px) env(safe-area-inset-left, 0px);
  height: 100%;
  overflow: hidden;
  user-select: none;
  -webkit-user-select: none;
  -webkit-touch-callout: none;
  touch-action: manipulation;
}

#app {
  min-height: 100vh;
  min-height: 100dvh;
}

.h1 {
  font-size:8vw;
  line-height:8vw;
  font-weight:500;
}

.h2 {
  font-size:3vw;
  font-weight:500;
}

.h3 {
  font-size:2vw;
}

.flex-start {
  justify-items:start;
}

.flex-vertical {
  flex-direction:column;
}

.flex {
  display:flex;
  align-items:center;
}

.justify-content-center {
  justify-content: center;

}

.grid-heart {
  display:grid;
  grid-template-rows: 2fr 1fr 1fr;
}

.text-left {
  text-align: left;
}

.pointer {
  cursor: pointer;
  touch-action: manipulation;
}

svg {
  touch-action: manipulation;
  overflow: visible;
}
</style>
